import { h, Fragment } from "preact";
import ProductOptionSwatch from "./product-option-swatch";

export default function ProductOptionSwatchesGroup({
  groupTitle,
  optionValues,
  selectedOptionValue,
  disabledOptionValues,
  variantsByOptionValue,
  unavailableOptionValues,
  waitlistOptionValues,
  updateOptionValue,
  optionName,
  disabledSwatchStyle,
  optionSize,
  setPreviewOpen,
}) {
  const title = groupTitle || optionName;

  return (
    <div className="product-options__swatch-group">
      {
        <div className="product-options__swatch-group-header">
          <div className="product-options__swatch-group-title">{title}</div>
        </div>
      }
      <fieldset className="product-options__swatch-list">
        <legend className="visually-hidden">{title}</legend>
        {optionValues.map((optionValue) => (
          <ProductOptionSwatch
            key={optionValue.name}
            optionValue={optionValue}
            optionName={optionName}
            disabled={disabledOptionValues.includes(optionValue.name)}
            unavailable={unavailableOptionValues.includes(optionValue.name)}
            waitlist={waitlistOptionValues.includes(optionValue.name)}
            optionVariant={variantsByOptionValue.find(
              (variantByOptionValue) =>
                variantByOptionValue.optionValue === optionValue.name,
            )}
            updateOptionValue={updateOptionValue}
            selected={optionValue.name === selectedOptionValue}
            onClick={() => setPreviewOpen(true)}
            disabledSwatchStyle={disabledSwatchStyle}
            optionSize={optionSize}
          />
        ))}
      </fieldset>
    </div>
  );
}
